export const PERMISSIONS = {
  TOURNAMENTS_MANAGE: 'tournaments.manage',
  PLAYERS_MANAGE: 'players.manage',
  TEAMS_MANAGE: 'teams.manage',
  NEWS_MANAGE: 'news.manage',
  MAP_SUBMISSIONS_REVIEW: 'mapSubmissions.review',
  MAP_IMAGES_MANAGE: 'mapImages.manage',
  MEDIA_MANAGE: 'media.manage',
  CONTENT_EDIT: 'content.edit',
  SERVERS_MANAGE: 'servers.manage',
  STAFF_MANAGE: 'staff.manage',
  MAP_OF_THE_WEEK_MANAGE: 'mapOfTheWeek.manage',
  USERS_MANAGE: 'users.manage',
  PROFILE_COMMENTS_MODERATE: 'profileComments.moderate',
};

export const PERMISSION_META = {
  [PERMISSIONS.TOURNAMENTS_MANAGE]: {
    label: 'Manage tournaments',
    description: 'Create, edit, and delete tournaments globally.',
    group: 'Tournaments',
  },
  [PERMISSIONS.PLAYERS_MANAGE]: {
    label: 'Manage players',
    description: 'Edit the global players roster.',
    group: 'Tournaments',
  },
  [PERMISSIONS.TEAMS_MANAGE]: {
    label: 'Manage teams',
    description: 'Edit the global teams roster.',
    group: 'Tournaments',
  },
  [PERMISSIONS.NEWS_MANAGE]: {
    label: 'Manage news',
    description: 'Create, edit, publish, and delete news posts.',
    group: 'Content',
  },
  [PERMISSIONS.MAP_SUBMISSIONS_REVIEW]: {
    label: 'Review map submissions',
    description: 'Approve or reject user-submitted maps.',
    group: 'Maps & media',
  },
  [PERMISSIONS.MAP_IMAGES_MANAGE]: {
    label: 'Manage map image library',
    description: 'Upload, edit, and delete map images.',
    group: 'Maps & media',
  },
  [PERMISSIONS.MEDIA_MANAGE]: {
    label: 'Manage media library',
    description: 'Edit the media archive.',
    group: 'Maps & media',
  },
  [PERMISSIONS.CONTENT_EDIT]: {
    label: 'Edit site content',
    description: 'Edit landing page labels, hero image, and other site-wide text.',
    group: 'Content',
  },
  [PERMISSIONS.SERVERS_MANAGE]: {
    label: 'Manage game servers',
    description: 'Add, edit, and remove the CS2KZ servers shown on the public servers page.',
    group: 'Content',
  },
  [PERMISSIONS.STAFF_MANAGE]: {
    label: 'Manage staff page',
    description: 'Add, edit, and remove the people listed on the public staff page.',
    group: 'Content',
  },
  [PERMISSIONS.MAP_OF_THE_WEEK_MANAGE]: {
    label: 'Manage Map of the Week',
    description:
      'Set the weekly schedule and submission windows, override the picked course, and read the standings.',
    group: 'Maps & media',
  },
  [PERMISSIONS.USERS_MANAGE]: {
    label: 'Manage users & permissions',
    description: 'Grant or revoke roles and permissions. Super-admin-only.',
    group: 'Access',
  },
  [PERMISSIONS.PROFILE_COMMENTS_MODERATE]: {
    label: 'Moderate profile comments',
    description:
      'Review reported pin-wall comments, delete any comment, and ban or mute abusive users.',
    group: 'Moderation',
  },
};

export const PERMISSION_GROUPS = ['Tournaments', 'Content', 'Maps & media', 'Moderation', 'Access'];

export const ALL_PERMISSION_KEYS = Object.values(PERMISSIONS);
